import React, { useState, useEffect } from 'react';
import {
  FormGroup, Label, Modal, ModalHeader, ModalBody,
}
  from 'reactstrap';
import PropTypes from 'prop-types';
import { useToasts } from 'react-toast-notifications';
import { useMutation, useLazyQuery } from 'react-apollo';
import ArtistRegisterForm from '../register/ArtistRegisterForm';
import ManagerRegisterForm from '../register/ManagerRegisterForm';
import { getLocalUserData, staticConstants, handleGraphqlError } from '../../../utils';
import Loading from '../loadingOverlay/Loading';
import { GET_USER_DATA_QUERY, GET_ACTIVE_ARTIST, GET_ALL_ARTIST_QUERY } from '../../../graphql-client/queries';
import { UPDATE_USER, LOADER_MUTATION } from '../../../graphql-client/mutations';


function UpdateProfileForm(props) {
  const { addToast } = useToasts();
  const userData = getLocalUserData();
  const { isOpen } = props;
  const [modal, setModal] = useState(isOpen);
  const [getUserData, setGetUserData] = useState(null);

  const [activeArtistQuery, { loading: activeArtistLoading, data: activeArtistData },
  ] = useLazyQuery(GET_ACTIVE_ARTIST, { skip: userData.role !== staticConstants.ROLE.MANAGER });
  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: false },
  });
  const [getUserQuery, {
    loading: getUserLoading, data,
  }] = useLazyQuery(GET_USER_DATA_QUERY, { variables: {} });

  const toggle = () => {
    setModal(!modal);
    props.onClose(false);
  };

  const getUserFetchVariables = () => {
    if (activeArtistData) {
      return { userId: activeArtistData.activeArtist._id };
    }
    return {};
  };
  const updateUserRefetchQueries = [{ query: GET_USER_DATA_QUERY, variables: getUserFetchVariables() }];
  const [updateArtistProfile] = useMutation(UPDATE_USER, {
    variables: {},
    refetchQueries: userData.role === staticConstants.ROLE.MANAGER ? [
      ...updateUserRefetchQueries, { query: GET_ALL_ARTIST_QUERY }]
      : updateUserRefetchQueries,
    onError(err) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(profileData) {
      loaderMutate({ variables: { show: false } });
      addToast(profileData.updateUser.message, { appearance: 'success' });
      props.onClose(false);
    },

  });
  useEffect(() => {
    activeArtistQuery();
  }, [activeArtistData, activeArtistQuery]);

  useEffect(() => {
    data && setGetUserData(data.getUser.data);
  }, [data]);

  useEffect(() => {
    getUserQuery();
  }, []);

  useEffect(() => {
    if (activeArtistData) {
      getUserQuery({ userId: activeArtistData.activeArtist._id });
    }
  },
  [activeArtistData]);
  if (getUserLoading || activeArtistLoading) {
    return <Loading active />;
  }

  const onSubmitCallBack = (profileData) => {
    if (activeArtistData) {
      profileData = { ...profileData, ...{ userId: activeArtistData.activeArtist._id } };
    }
    updateArtistProfile({ variables: profileData });
    loaderMutate({ variables: { show: true } });
  };

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      className="modal-signup"
      keyboard={false}
    >
      <ModalHeader toggle={toggle} className="modal-blank-header" />
      <ModalBody>
        <FormGroup className={`select-user ${userData ? 'mt-0' : ''}`}>
          <Label className="font-italic">
            <span>
              { userData.role === staticConstants.ROLE.MANAGER
                ? staticConstants.TITLE.MANAGER : staticConstants.TITLE.ARTIST }
            </span>
            {' '}
          </Label>
        </FormGroup>


        {
          userData.role === staticConstants.ROLE.MANAGER && getUserData && (
            <ManagerRegisterForm
              toggle={toggle}
              submitCallBack={onSubmitCallBack}
              data={getUserData}
            />
          )
        }
        {
          userData.role === staticConstants.ROLE.ARTIST && getUserData
            && (
            <ArtistRegisterForm
              toggle={toggle}
              data={getUserData}
              submitCallBack={onSubmitCallBack}
            />
            )
        }
      </ModalBody>
    </Modal>
  );
}

UpdateProfileForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

UpdateProfileForm.defaultProps = {
  onClose: null,
};
export default UpdateProfileForm;
